// extracted by mini-css-extract-plugin
export default {"highLevelLabel":"HighLevelGuidelines_highLevelLabel__fEUGW","addButton":"HighLevelGuidelines_addButton__UcPo6","highLevelContainer":"HighLevelGuidelines_highLevelContainer__5VR4f"};